export default "__VITE_ASSET__QVLi9vWD__"